import React, { FC } from 'react'

export const Signal: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99 1.002 10.308 1c.054 0 .101.002.155.005 4.785.252 8.52 4.21 8.517 8.988a1 1 0 0 1-2-.001 6.995 6.995 0 0 0-6.385-6.973L10.317 3l-.327.002a1 1 0 0 1 0-2ZM2 8.992a1 1 0 0 1 1 1 6.994 6.994 0 0 0 6.377 6.974l.282.018.331-.002a1 1 0 1 1 0 2l-.394.001-.08-.003C4.732 18.728.998 14.77 1 9.992a1 1 0 0 1 1-1Zm8.99 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-4 0a1 1 0 1 0-2 0 5 5 0 0 0 5 5 1 1 0 1 0 0-2 3 3 0 0 1-3-3Zm8 0a5 5 0 0 0-5-5 1 1 0 1 0 0 2 3 3 0 0 1 3 3 1 1 0 1 0 2 0Z"
      fill="#262628"
    />
  </svg>
)
